var CryptoJS = require("crypto-js");

const baseUrl = `http://r365server.businesssalesmachine.com/subs/`;
export const socketUrl = `http://r365server.businesssalesmachine.com/`;
// const baseUrl = `http://localhost:3001/subs/`;
// export const socketUrl = `http://localhost:3001/`;

export const RequestUrls = {
    Login: `${baseUrl}login`,
};
export const RequestGet = async (url) =>{
    try{
    const data = await fetch(url)
    return data.json();
    }catch (err) {
    }
}
export const RequestPost = async (url,body) =>{
    try{
        const response = await fetch(url,{
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body) // body data type must match "Content-Type" header
        });
        return response.json();
    }catch (err) {
    }
}
const userDetails = () =>{
    const data = localStorage.getItem('user');
    if(data){
        var bytes  = CryptoJS.AES.decrypt(data, 'userRead369Books');
        var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return decryptedData;
    }else{
        return undefined;
    }

}
export const isUserAuthenticated = () =>{
    const details = userDetails();
    return details ? true: false;
}
export const getUserDetails = () =>{
    const details = userDetails();
    return details;
}
export const userLogout = (navigation) =>{
    localStorage.removeItem('user');
    navigation('/');
}
